import React from "react";
import { useAppSelector } from "../../../../redux";
import "./PartnerPortalWelcomeHeader.scss";

const PartnerPortalWelcomeHeader: React.FC = () => {
  const { partnerDetails } = useAppSelector((state) => state.partner_details);

  const partnerName = partnerDetails?.partner_name?.trim() || "Partner";

  const partnerTypeLabel = Array.isArray(partnerDetails?.partner_type)
    ? partnerDetails.partner_type.join(", ")
    : partnerDetails?.partner_type || "—";

  const statusLabel = partnerDetails?.status || "—";
  const isActivePartner = statusLabel.toLowerCase() === "active";

  return (
    <div className="partner-portal-welcome-header partner-short-details">
      <div className="partner-portal-welcome-header__identity partner-short-details__identity">
        <div className="name-and-details">
          <div className="name">Welcome back, {partnerName}</div>
          <p className="partner-portal-welcome-header__subtitle">
            Track your program status, manage projects, and grow your partnership
            with HID Origo.
          </p>
        </div>
      </div>

      <div className="partner-portal-welcome-header__badges">
        <span className="badge badge--partner-type">
          Partner Type: <strong>&nbsp;{partnerTypeLabel}</strong>
        </span>
        <span
          className={`badge badge--status ${
            isActivePartner ? "badge--status-active" : "badge--status-inactive"
          }`}
        >
          Support Contract Status: <strong>&nbsp;{statusLabel}</strong>
        </span>
      </div>
    </div>
  );
};

export default PartnerPortalWelcomeHeader;
